import { render, staticRenderFns } from "./PendingProfileUpdateRequest.vue?vue&type=template&id=31e59ac4&"
import script from "./PendingProfileUpdateRequest.vue?vue&type=script&lang=js&"
export * from "./PendingProfileUpdateRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports